<template>
  <s-modal
    v-model="showModal"
    class="linked-users-list-modal"
    ok-only
    :title="$t('profile-manager.query.linked-users-modal.title')"
    :is-loading="loading"
    @ok="closeModal"
  >
    <div class="linked-users-list-modal__content">
      <b-form-checkbox
        v-model="filterUsers"
        class="linked-users-list-modal__filter-checkbox"
        @change="onChangeFilter"
      >
        {{ $t('profile-manager.query.linked-users-modal.filter-by-selected-profiles') }}
      </b-form-checkbox>
      <s-table
        class="no-align linked-users-list-modal__table"
        :fields="fields"
        :items="users"
        :busy="loading"
      />
    </div>
  </s-modal>
</template>

<script>
import LoadingMixin from '@/services/loadingMixin';
import Service from '@/domain/services/generalPanel/adminPanel/profile/profileService';

export default {
  props: {
    value: {
      type: Boolean,
    },
    profilesIds: Array,
    filterOnlySelectedProfile: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    LoadingMixin,
  ],
  data() {
    return {
      users: [],
      filterUsers: false,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    fields() {
      return [
        {
          key: 'userName',
          sortable: false,
          label: this.$t('profile-manager.query.linked-users-modal.column-titles.user'),
        },
        {
          key: 'profile',
          sortable: false,
          class: 'linked-users-list-modal__cell-profile',
          label: this.$t('profile-manager.query.linked-users-modal.column-titles.profile'),
        },
      ];
    },
  },
  methods: {
    onChangeFilter(filterOnlySelectedProfile) {
      this.listUsers(filterOnlySelectedProfile);
    },
    async listUsers(filterOnlySelectedProfile) {
      this.startLoading();
      try {
        this.users = await Service.getLinkedUsers(this.profilesIds, filterOnlySelectedProfile);
      } finally {
        this.endLoading();
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
  watch: {
    profilesIds() {
      this.users = [];
      this.filterUsers = this.filterOnlySelectedProfile;
      if (this.profilesIds && this.profilesIds.length > 0) {
        this.listUsers(this.filterUsers);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.linked-users-list-modal
  &__content
    display: flex
    flex-direction: column
  &__filter-checkbox
    margin-bottom: 20px
  &__table
    height: 250px
  ::v-deep &__cell-profile
    text-align: center
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
